import { useContext as useReactContext } from "react";

import { sessionContext } from "context/session/sessionContext";

export const useSession = () => {
  const value = useReactContext(sessionContext);
  if (value === undefined) throw new Error("useSession call does not descend from a matching SessionProvider");
  return value;
};
